import React, { Component } from 'react';
import { Field, change } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import classNames from 'classnames';
import _ from 'lodash';

import { InputField } from '../Common/inputField';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Selection, MultiSelection } from '../Common/selection';
import { DatePicker } from '../Common/datePicker';
import { formatDate } from '../Common/dateFormat';
import ConfirmActionModal from '../Common/confirmActionModal';
import ARModifiableTable from './EditAR/arModifiableTable';
import AccountDropdown from './accountDropdown';
import PaymentMethodOptions from '../Common/arapPaymentOptions';

class EditAR extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      unpaidAmount: 0,
      totalAmount: 0,
      checkAuthorizeOpen: false,
      action: null,
      waiveShouldDisable: true,
      waiveAmount: 0,
      penaltyAmount: 0,
      totalPayment: 0,
      isAREditable: false,
    };
    this.renderWaiveCheckbox = this.renderWaiveCheckbox.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.handleWaiveCheckboxChange = this.handleWaiveCheckboxChange.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.handleWaiveInputChange = this.handleWaiveInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentWillMount() {

  }

  componentDidMount() {
    this.props.clearARForm();
    this.props.clearCredits();
    const { routeParams: { id } } = this.props;
    if (id) {
      this.props.fetchARDetail(id);
    } else {
      this.context.router.push('/AR/');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.penaltyAmount !== this.props.penaltyAmount) {
      const penaltyAmount = parseFloat(nextProps.penaltyAmount) || 0;
      this.setState({ penaltyAmount });
    }
    if (nextProps.arDetail && nextProps.arDetail !== this.props.arDetail) {
      const {
        Status,
        Invoices,
        Waive,
        WaiveAmount,
        PenaltyAmount,
        TotalPayment,
      } = nextProps.arDetail;
      const isAREditable = Status === 'Bounced Check' ||
                           Status === 'Void';
      let totalAmount = 0;
      if (Invoices) {
        Invoices.map(invoice => {
          totalAmount += invoice.PreviousBalance;
        });
      }
      this.setState({
        rows: Invoices || [],
        waiveShouldDisable: !Waive,
        waiveAmount: WaiveAmount,
        penaltyAmount: PenaltyAmount,
        isAREditable,
        totalPayment: TotalPayment,
        totalAmount,
      });
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      if (this.state.action === 'apply') {
        this.handleFormSubmit();
      } else if (this.state.action === 'remove') {
        this.props.deleteAR(this.props.arDetail.Payment_id);
      } else if (this.state.action === 'bounce') {
        this.props.bounceCheck(this.props.arDetail.Payment_id);
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { totalPayment } = this.state;
    if (totalPayment !== prevState.totalPayment) {
      this.props.dispatch(change('editAR', 'TotalPayment', parseFloat(totalPayment).toFixed(2) || 0));
    }
  }

  getBsStyle(input, value) {
    return input === value ? 'success' : 'primary';
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  calculateWaiveAmount() {
    const discount = parseFloat(this.props.discount) || 0;
    const totalAmount = parseFloat(this.state.totalAmount) || 0;
    let finalAmount = ((100 - discount) / 100) * totalAmount;
    finalAmount = finalAmount.toFixed(2) || 0;
    const totalPayment = parseFloat(this.props.totalPayment) || 0;
    let waiveAmount = finalAmount - totalPayment;
    waiveAmount = waiveAmount.toFixed(2);
    return waiveAmount;
  }

  debouncedEditAR = _.debounce((formProps, rows) => {
    this.props.editAR(formProps, rows).then(
      () => {
        if (this.props.arEdited && !this.props.arEditError) {
          this.props.router.push('/AR');
        }
      }
    );
  }, 500, { maxWait: 1000 })

  handleFormSubmit() {
    const formProps = {
      Customer: this.props.customer_id,
      Payment_id: this.props.arDetail.Payment_id,
      TotalPayment: parseFloat(this.props.totalPayment || 0).toFixed(2),
      PaymentDate: this.props.paymentDate,
      PenaltyAmount: parseFloat(this.props.penaltyAmount || 0).toFixed(2),
      Method: this.props.method,
      CheckNum: this.props.checkNum,
      Account: this.props.account.value,
      AccountName: this.props.account.label,
      // Discount: parseFloat(this.props.discount) || 0,
      // DiscountedAmount: ((parseFloat(this.state.totalAmount) * parseFloat(this.props.discount)) / 100).toFixed(2) || 0,
      Note: this.props.note,
      Waive: this.props.waive,
      WaiveAmount: parseFloat(this.state.waiveAmount || 0).toFixed(2),
      TotalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2),
    };
    const { rows } = this.arTable.state;

    this.debouncedEditAR(formProps, rows);
    //TODO show modal ask for staying on the page
  }

  getBillingAddress() {
    const { arDetail } = this.props;
    let Address1 = '';
    let Address2 = '';
    if (arDetail && arDetail.Customer_Detail) {
        Address1 = arDetail.Customer_Detail.Street;
        Address2 = `${arDetail.Customer_Detail.City}, ${arDetail.Customer_Detail.State} ${arDetail.Customer_Detail.Zip}`;
    }
    return [Address1, Address2];
  }

  getCreditOptions() {
    const creditOptions = [];
    if (this.props.credits) {
      this.props.credits.map(credit => {  //check the field name of credits when backend finish the API
        creditOptions.push({ value: credit.SalesReturn_id, label: `${credit.SRNum} | ${credit.FinalPrice}` });
      });
    }
    return creditOptions;
  }

  checkPermission(permission) {
    return false;
  }

  handleWaiveCheckboxChange(event) {
    const target = event.target;
    if (!target.checked) {
      this.props.setDefaultOfForm('WaiveAmount', 0.00, 'editAR');
      this.setState({
        waiveAmount: 0.00,
      });
    } else {
      this.props.setDefaultOfForm('WaiveAmount', this.calculateWaiveAmount(), 'editAR');
      this.setState({
        waiveAmount: this.calculateWaiveAmount(),
      });
    }
    this.setState({
      waiveShouldDisable: !target.checked,
    });
  }

  handleWaiveInputChange(event) {
    this.setState({
      waiveAmount: event.target.value,
    });
  }

  handlePaymentCellChange = (rows) => {
    let totalPayment = 0;
    let totalAmount = 0;
    rows.map(row => {
      totalPayment += parseFloat(row.Amount) || 0;
      totalAmount += parseFloat(row.PreviousBalance) || 0;
    });
    this.setState({
      totalPayment,
      totalAmount,
    });
  }

  // handleTotalBalanceChange = (rows) => {
  //   let totalBalance = 0;
  //   rows.map(row => {
  //     totalBalance += parseFloat(row.UnpaidAmount) || 0;
  //   });
  //   this.setState({ totalBalance });
  // }

  handlePaymentAmountInputChange = (event) => {
    // charCode 13 = key 'Enter'
    // if (event.charCode === 13) {
      let payment = parseFloat(event.target.value || 0).toFixed(2) || 0;
      const rows = [...this.state.rows];
      for (let i = 0; i < rows.length; i++) {
        const rowToUpdate = rows[i];
        const { PreviousBalance } = rowToUpdate;
        const unpaidAmount = PreviousBalance || 0;
        if (payment >= unpaidAmount) {
          rowToUpdate.Amount = +parseFloat(unpaidAmount).toFixed(2);
          rowToUpdate.UnpaidAmount = 0;
          payment -= unpaidAmount;
        } else {
          rowToUpdate.Amount = +parseFloat(payment).toFixed(2);
          rowToUpdate.UnpaidAmount = +parseFloat(parseFloat(unpaidAmount) - parseFloat(payment)).toFixed(2);
          payment = 0;
        }
        // overpay condition, add payment to last row
        if (payment > 0 && i === rows.length - 1) {
          rowToUpdate.Amount += +parseFloat(payment).toFixed(2);
          rowToUpdate.UnpaidAmount -= +parseFloat(payment).toFixed(2);
        }
        rows[i] = rowToUpdate;
        // totalAmount += PreviousBalance;
      }
      this.setState({ rows });
    // }
  }

  // handleDiscountInputChange = (event) => {
  //   if (event.charCode === 13) {
  //     const { discount } = this.props;
  //     const rows = [...this.state.rows];
  //     rows.map(row => {
  //       const discountAmount = ((parseFloat(row.PreviousBalance) * parseFloat(discount)) / 100).toFixed(2);
  //       row.DiscountedAmount = discountAmount || 0;
  //     });
  //     this.setState({ rows });
  //   }
  // }

  renderCustomers() {
    const { arDetail, arDetailIsLoading, arDetailError } = this.props;
    if (!arDetail || arDetailIsLoading) {
      return <Spinner />;
    } else if (arDetailError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const { CustomerNum, CustomerName, Customer_Detail } = arDetail;
    let contact = null;
    let phone = null;
    let note = '';
    let billingAddress = ['', ''];

    if (Customer_Detail) {
      contact = `${Customer_Detail.FirstName} ${Customer_Detail.LastName}`;
      phone = Customer_Detail.Telephone;
      billingAddress = this.getBillingAddress();
      note = Customer_Detail.Note;
    }

    return (
      <div>
        <Row className='mb0'>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="customer_no" />
              <span style={{ color: 'red' }} >*</span>
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={CustomerNum}
                disabled
              />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="customer_name" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={CustomerName}
                disabled
              />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="phone" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={phone}
                disabled
              />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="description" />
            </label>
            <Col sm={8} className='mb-md'>
              <Input
                type='text'
                value={note}
                disabled
              />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-3'>
              <Translate value="contact" />:
            </label>
            <Col sm={9}>
              { contact }
            </Col>
            <label className='col-sm-3'>
              <Translate value="address" />:
            </label>
            <Col sm={9}>
              { billingAddress[0] }
              <br />
              { billingAddress[1] }
            </Col>
          </Col>
        </Row>
      </div>
    );
  }

  renderInvoices() {
      if (this.props.invoicesIsLoading && !this.props.invoicesError) {
        return <Spinner />;
      } else if (this.props.invoicesError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>
              <Translate value="something_unexpected_happened" />
            </div>
          </ContentWrapper>
        );
      }
      const { rows, isAREditable } = this.state;
      return (
        <Row>
          <Col sm={12}>
            <ARModifiableTable
              ref={(arTable) => { this.arTable = arTable; }}
              rows={rows}
              handlePaymentCellChange={this.handlePaymentCellChange}
              handleTotalBalanceChange={this.handleTotalBalanceChange}
              editable={!isAREditable}
            />
          </Col>
        </Row>
      );
  }

  renderCheckNum() {
    return (
      <Field name='CheckNum' component={InputField} />
    );
  }

  renderCredits() {
    if (this.props.creditsIsLoading && !this.props.creditsError) {
      return <Spinner />;
    } else if (this.props.creditsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
    return (
      <Field name='Credits' component={MultiSelection} options={creditOptions} />
    );
  }

  renderResponse() {
    const { arEdited, arEditError, arIsEditing } = this.props;
    if (arEdited) {
      return (
        <ContentWrapper>
          <div className='alert alert-success'>Success!</div>
        </ContentWrapper>
      );
    } else if (arIsEditing && !arEditError) {
      return (
        <ContentWrapper>
          <div className='alert alert-info'>
            ...<Translate value="reading_data" />
          </div>
        </ContentWrapper>
      );
    } //else if (arEditError) {
    //   return (
    //     <ContentWrapper>
    //       <div className='alert alert-danger'>
    //         { arEditError }
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    return <ContentWrapper />;
  }

  renderWaiveCheckbox(props) {
    return (
      <div className='form-group'>
        <Col xs={6}>
          <label>
            <input
              {...props.input}
              type='checkbox'
              value='waive'
              checked={props.input.value}
              onChange={this.handleWaiveCheckboxChange}
            />
          </label>
        </Col>
      </div>
    );
  }

  renderInputField = (props) => {
    const { meta: { touched, error }, className } = props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        <Input
          {...props.input}
          className={inputClass}
          type='text'
          onChange={(event) => {
            props.input.onChange(event);
            props.handleOnChange(event);
          }}
          disabled={props.disabled}
        />
        {touched && error && <span className='parsley-error-message'>{error}</span>}
      </div>
    );
  }

  renderARMetaInfo() {
    const { arDetail } = this.props;
    return (
      <Row>
        <Col xs={2}>
          <Row>
            <Col xs={2}>
              <label><Translate value="id" /></label>
            </Col>
            <Col xs={8}>
              <Input
                type='text'
                value={(arDetail && arDetail.ARNum) || ''}
                disabled
              />
            </Col>
          </Row>
        </Col>
        <Col xs={10}>
          <Row>
            <Col xs={3}>
              <Row>
                <Col xs={3} xsOffset={1}>
                  <label><Translate value="user" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(arDetail && arDetail.FullName) || 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="creation_date" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(arDetail && arDetail.PostingDate) ? formatDate(new Date(arDetail.PostingDate)) : 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="modified_date" /></label>
                </Col>
                <Col xs={7}>
                  <Input
                    type='text'
                    value={(arDetail && arDetail.ModifyDate) ? formatDate(new Date(arDetail.ModifyDate)) : 'N/A'}
                    disabled
                  />
                </Col>
              </Row>
            </Col>
            <Col xs={3}>
              <Row>
                <Col xs={4}>
                  <label><Translate value="payment_date" /></label>
                </Col>
                <Col xs={7}>
                  <Field name='PaymentDate' component={DatePicker} dropUp maxDate={new Date()} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };

    const { pristine, method, submitting } = this.props;
    const {
      waiveShouldDisable,
      isAREditable,
      waiveAmount,
      penaltyAmount,
    } = this.state;

    const paymentMethodIsCredit = (method === 'Credit' || (method && method.value === 'Credit'));

    const twoDecimalZero = (0).toFixed(2);
    const discount = parseFloat(this.props.discount) || twoDecimalZero;
    const totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
    const balance = (((100 - discount) / 100) * totalAmount).toFixed(2) || twoDecimalZero;
    const totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
    const finalBalance = (penaltyAmount + (balance - waiveAmount - totalPayment)).toFixed(2) || twoDecimalZero;
    // finalBalance = finalBalance > 0 ? finalBalance : twoDecimalZero;

    return (
      <ContentWrapper>
        <form method='get' action='#'>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="ar_slashsign_ap" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active='true'>
              <Translate value="account_receivable" />
            </Breadcrumb.Item>
          </Breadcrumb> {/* End Navigation Trail */}
          <Grid id='AR-edit'>
            <ButtonToolbar>
              <Button
                bsStyle='danger'
                type='button'
                onClick={() => { this.props.router.push('/AR'); }}
              >
                <em className='fa fa-close' />
              </Button>
            </ButtonToolbar>
            <Panel id='customers'>
              { this.renderCustomers() }
            </Panel>
            <Panel>
              { this.renderInvoices() }
            </Panel>
            <Panel id='check-out-information'>
              { this.renderARMetaInfo() }
              <div className='horizontal-divider' />
              <Row className="upper-row-positioning">
                <Col sm={1}>
                  <label className='text-nowrap inlineLabel' >
                    <Translate value="payment_method" />
                    <span className='asteriksReq'>*</span>
                  </label>
                </Col>
                <Col sm={2}>
                  <Field
                    name='Method'
                    className='select-menu-drop-up'
                    component={Selection}
                    options={PaymentMethodOptions}
                    disabled={isAREditable}
                  />
                </Col>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="check_number" />
                  </label>
                </Col>
                <Col sm={2}>
                  { paymentMethodIsCredit && this.renderCredits() }
                  { !paymentMethodIsCredit && this.renderCheckNum() }
                </Col>
                {/*
                  <Col sm={2}>
                    <Row>
                      <Col sm={6}>
                        <label className='inlineLabel' >
                          <Translate value="discount" /> (%)
                        </label>
                      </Col>
                      <Col sm={5}>
                        <Field
                          name='Discount'
                          component={InputField}
                          onKeyPress={this.handleDiscountInputChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                /*}
                {/* Waive section */}
                <Col sm={2}>
                  <Row>
                    <Col sm={3}>
                      <label className='inlineLabel' >
                        <Translate value="waive" />
                      </label>
                    </Col>
                    {/*
                      <Col sm={2}>
                        <Field name='Waive' component={this.renderWaiveCheckbox} />
                      </Col>
                    */}
                    <Col sm={6} smOffset={1}>
                      <Field
                        name='WaiveAmount'
                        component={this.renderInputField}
                        handleOnChange={this.handleWaiveInputChange}
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Row>
                    <Col xs={4}>
                      <label><Translate value="penalty" /></label>
                    </Col>
                    <Col xs={6}>
                      <Field
                        name='PenaltyAmount'
                        component={InputField}
                        disabled={isAREditable}
                      />
                    </Col>
                  </Row>
                </Col>
                {/* End waive section */}
                <Col sm={1}>
                  <label>
                    <Translate value="balance" /> :
                  </label>
                </Col>
                <Col sm={1}>
                  <label>
                    { balance }
                  </label>
                </Col>
              </Row>
              <Row className="lower-row-positioning">
                <label className='col-sm-1 inlineLabel' >
                  <Translate value="account" />
                  <span style={{ color: 'red' }} >*</span>
                </label>
                <Col sm={2}>
                  {/*<Field name='Account' component={InputField} />*/}
                  <AccountDropdown className='select-menu-drop-up'/>
                </Col>
                <label className='col-sm-1 text-nowrap inlineLabel' >
                  <Translate value="receive_amount" />
                  <span className='asteriksReq'>*</span>
                </label>
                <Col sm={2} className="total-payment-field">
                  <Field
                    name='TotalPayment'
                    component={this.renderInputField}
                    handleOnChange={this.handlePaymentAmountInputChange}
                    disabled={isAREditable}
                  />
                </Col>
                <Col sm={4}>
                  <Row>
                    <Col sm={2}>
                      <label className='inlineLabel' >
                        <Translate value="note" />
                      </label>
                    </Col>
                    <Col sm={8}>
                      <Field
                        name='Note'
                        component={InputField}
                        disabled={isAREditable}
                      />
                    </Col>
                  </Row>
                </Col>
                <label className='col-sm-1'>
                  <Translate value="final_balance" /> :
                </label>
                <label className='col-sm-1'>
                  { finalBalance }
                </label>
              </Row>
              <div className="horizontal-divider divider" />
              <Row id='hint'>
                <Col sm={4} className="vertical-divider">
                  <ButtonToolbar id="ar-apply-button">
                    <Button
                      bsStyle='success'
                      type='button'
                      onClick={() => { this.openCheckAuthorize('apply'); }}
                      disabled={submitting || isAREditable}
                    >
                      <em className="fa fa-save" /><Translate value="save" />
                    </Button>
                    <Button
                      bsStyle='danger'
                      type='button'
                      onClick={() => { this.openCheckAuthorize('remove'); }}
                      disabled={submitting || isAREditable}
                    >
                      <Translate value="remove" />
                    </Button>
                    <Button
                      bsStyle=''
                      onClick={() => { this.openCheckAuthorize('bounce'); }}
                      disabled={submitting || isAREditable}
                    >
                      <Translate value="bounced_check" />
                    </Button>
                  </ButtonToolbar>
                </Col>
                <Col sm={5}>
                  <label className='authorize-label'>
                    <Translate value="authorization_required" />
                  </label>
                </Col>
              </Row>
            </Panel>
            <Row>
              {this.renderResponse()}
            </Row>
          </Grid>
        </form>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case='confirmPassword'
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default EditAR;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/editAR.jsx